import { useState } from "react";
import SideBar from "../../../components/SideBar";
import Navigation from "../../../components/Navigation";
import Footer from "../../../components/Footer";
import LogOutModal from "../../../components/modals/LogOutModal";
import ClientsTables from "../../../components/tables/ClientsTables";
import CreateClientModal from "../../../components/modals/clients/CreateClientModal";
import EditClientModal from "../../../components/modals/clients/EditClientModal";

const ClientIndex = () => {
  const [open, setOpen] = useState(false);
  const [openCreateClientModal, setOpenCreateClientModal] = useState(false);
  const [openEditClientModal, setOpenEditClientModal] = useState(false)
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [clientData, setClientData] = useState({});

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  const toggleLogOutModal = () => {
    setOpen(!open);
  };

  const toggleCreateClientModal = () => {
    setOpenCreateClientModal(!openCreateClientModal);
  };

  const toggleEditClientModal = (data) => {
    setClientData(data)
    setOpenEditClientModal(!openEditClientModal);
  };

  const pageTitle = "Clients";
  const breadcrumbs = [{ text: "Home", link: "/" }, { text: "Clients" }];

  return (
    <div className="m-0 font-sans antialiased font-normal text-base leading-default bg-gray-50 text-slate-500">
      <SideBar
        options={{ open, toggleLogOutModal }}
        isSidebarOpen={isSidebarOpen}
        toggleSidebar={toggleSidebar}
      />

      <main className="ease-soft-in-out xl:ml-68.5 relative h-full max-h-screen rounded-xl transition-all duration-200">
        <Navigation
          pageTitle={pageTitle}
          breadcrumbs={breadcrumbs}
          isSidebarOpen={isSidebarOpen}
          toggleSidebar={toggleSidebar}
        />

        <div className="w-full px-6 py-6 mx-auto">
          <ClientsTables options={{ toggleCreateClientModal, toggleEditClientModal }} />
          <Footer />
        </div>
      </main>
      <LogOutModal options={{ open, setOpen, toggleLogOutModal }} />

      <CreateClientModal
        options={{
          openCreateClientModal,
          setOpenCreateClientModal,
          toggleLogOutModal,
        }}
      />

    <EditClientModal
        options={{
          openEditClientModal, setOpenEditClientModal, toggleEditClientModal, clientData
        }}
      />
    </div>
  );
};

export default ClientIndex;
